
import { DashboardMenu } from "../../data/menu"
import { useTranslation } from 'react-i18next';

import BreadCrump from "../tools/breadcrump"
import DashboardButton from "../Setting/dashboardButton";

export default function IndexBlog() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name:'Blog',
            url: null
        },
    ]
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4   h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Blogs" DashboardMenu={DashboardMenu}></DashboardButton>

            
               
                
            </div>

        </>
    )
}